module.exports = __webpack_public_path__ + "static-portal/img/1.ca6d515.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1.png
// module id = LOA1
// module chunks = 4